export default "__VITE_ASSET__qUuqmdS8__"